
export default function LibraryContentCard({ handleClik, content }) {
   return (
      <article className='Library-content-container'  onClick={() => handleClik(content)}>
         {content?.image && <img
            className='Library-content--image' 
            alt={`portada de ${content?.title}`}
            src={content?.image} />}
         <h3 className='Library-content--title--overlflow'>{content?.title}</h3>
      </article>
   )
}
